import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { InfoTooltip } from '~/components/Tooltip/InfoTooltip';
import { CardPaper } from '../lib';

interface StatCardProps {
  label: string;
  value: string;
  tooltip: string;
  icon: ReactNode;
  subtitle?: string;
}

export const StatCard = ({ label, value, tooltip, icon, subtitle }: StatCardProps) => (
  <CardPaper sx={{ p: 2, height: '100%' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ color: 'primary.main', display: 'flex', '& svg': { fontSize: 28 } }}>{icon}</Box>
        <Typography component="h2" variant="subtitle1" fontWeight={600} color="text.secondary">
          {label}
        </Typography>
      </Box>
      <InfoTooltip title={tooltip} placement="top" />
    </Box>
    <Box sx={{ height: 48, display: 'flex', alignItems: 'center' }}>
      <Typography sx={{ fontSize: 40, fontWeight: 600, lineHeight: 1.2 }}>{value}</Typography>
    </Box>
    {subtitle && (
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    )}
  </CardPaper>
);
